import React, { useEffect, useState } from 'react';
import {
  ButtonWrapper,
  CancelPolicyAccordionBody,
  InnerWrapperOne,
  InnerWrapperTwo,
  LeftWrapper,
  LoadIcon,
  LoadIconText,
  MainLeftWrapper,
  MainWrapper,
  OuterLeftWrapper,
  StyledPrimaryButton,
  StyledPrimaryButtonWithdraw,
  StyledPrimaryButtonWithdrawClicked,
  SuccessText,
  WrapperOne,
} from './gpaCancelPolicyStyles';
import { LayoutContainer } from '../policyInfo/PolicyInfoStyles';
import { CardLayout } from '../cardLayout/CardLayout';
import { formatDateAsString } from '../../util/formatters';
import SpinnerSrc from '../../assets/images/spinner-light.svg';
import { useLazyQuery, useQuery, useMutation } from 'react-apollo';
import { loader } from 'graphql.macro';
import BounceLoaderComponent from './Loader';
import { CancelPolicyFormWrap, SecurityOption, SecuritySelector, SelectorContainer, WarningText } from '../cancelPolicy/cancelPolicyForm/cancelPolicyFormStyles';
import CancellationDocument, {
  initialState as cancellationDocumentInitialState,
  isValid as isCancellationDocumentValid
} from '../cancelPolicy/cancelPolicyForm/formFields/cancellationDocument';

const get_uwreferral_lock = loader(
  './graphql/Get_UWReferral_Lock.graphql'
);

const withdraw_policy_cancel = loader(
  './graphql/Withdraw_Policy_Cancel.graphql'
);

const upload_policy_document_mutation = loader(
  './graphql/Cancel_Policy_Upload_Policy_Document.graphql'
);

const formatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'currency'
});

const initialState = (product: string, system: string) => ({
  cancellationDocument: cancellationDocumentInitialState
});

const CurrencyFormat = (amount: number | string | undefined | null) => {
  if (amount === undefined || amount === null) {
    return null;
  }

  if (['paid in full'].includes(amount?.toString()?.toLowerCase())) {
    return 'Paid in Full';
  }

  let numAmount = Number(amount.toString().replace(/[$,]/g, ''));

  if (Number.isNaN(numAmount)) {
    return null;
  }

  if (numAmount === 0) {
    numAmount = Math.abs(numAmount);
  }

  return numAmount < 0
    ? `- ${formatter.format(Math.abs(numAmount))}`
    : formatter.format(numAmount);
};

interface initialButtonStatusProps {
  withdraw: string;
  confirm: string;
  uwRefer: string;
}

const initialButtonStatus = {
  withdraw: 'notSubmitted',
  confirm: 'notSubmitted',
  uwRefer: 'notSubmitted'
};

const CancelPolicyInfoWrapper = (
  result: any,
  withdrawHandler: Function,
  confirmHandler: Function,
  uwReferalHandler: Function,
  buttonStatus: initialButtonStatusProps,
  systemCode: string,
  showUWReferralButton: boolean,
  showReferToUWButton: boolean,
  formState: any,
  setFormState: Function,
  handleChange: Function,
  securityType: string,
  setSecurityType: Function,
  uploadStatus: string,
  setUploadStatus: Function,
  warning: boolean,
  setWarning: Function
) => {

  useEffect(() => {
    if (formState.cancellationDocument.error) {
      setWarning(true);
    }
  }, [formState.cancellationDocument.error, buttonStatus]);

  return (
    <LayoutContainer >
      <CardLayout title="Cancel Policy Info">
        <MainWrapper>
          <MainLeftWrapper>
            <OuterLeftWrapper>
              <LeftWrapper>
                <WrapperOne>
                  <InnerWrapperOne>
                    Cancellation Effective Date:
                  </InnerWrapperOne>
                  <InnerWrapperTwo>
                    {formatDateAsString(result?.result?.effectiveDate) || ''}
                  </InnerWrapperTwo>
                </WrapperOne>
              </LeftWrapper>
              <LeftWrapper>
                <WrapperOne>
                  <InnerWrapperOne>
                    Reason for Cancellation:
                  </InnerWrapperOne>
                  <InnerWrapperTwo>
                    {result?.result?.cancellationDescription || ''}
                  </InnerWrapperTwo>
                </WrapperOne>
              </LeftWrapper>
              <LeftWrapper>
                <WrapperOne>
                  <InnerWrapperOne>
                    Refund Amount:
                  </InnerWrapperOne>
                  <InnerWrapperTwo>
                    {result?.result?.latestPeriod?.changeInCost ? CurrencyFormat(result?.result?.latestPeriod?.changeInCost?.amount) : ''}
                  </InnerWrapperTwo>
                </WrapperOne>
              </LeftWrapper>
              <LeftWrapper>
                <WrapperOne>
                  <InnerWrapperOne>
                    Refund Method:
                  </InnerWrapperOne>
                  <InnerWrapperTwo>
                    {result?.result?.cancellationRefundMethod?.charAt(0).toUpperCase() + result?.result?.cancellationRefundMethod?.slice(1) || 'Pro Rata'}
                  </InnerWrapperTwo>
                </WrapperOne>
              </LeftWrapper>
            </OuterLeftWrapper>
            {warning &&
              <WarningText>
                Signed copy of ACORD 35 or Other Acceptable Cancellation Form is required to be uploaded for cancellation.
              </WarningText>
            }
            {systemCode && systemCode === 'GWPL' && (
              <OuterLeftWrapper>
                <LeftWrapper style={{ 'width': '100%' }} >
                  <WrapperOne>
                    <CancellationDocument
                      state={formState.cancellationDocument}
                      onChange={(file: File, fileName: string) =>
                        handleChange('cancellationDocument', file, fileName)
                      }
                      disabled={false}
                      setSecurityType={setSecurityType}
                      setUploadStatus={setUploadStatus}
                      requestedBy={''}
                      uploadStatus={uploadStatus}
                      securityType={securityType}
                      product={systemCode}
                      isFirstPage={false} />
                  </WrapperOne>
                </LeftWrapper>
              </OuterLeftWrapper>
            )}
            {systemCode && systemCode === 'GWPL' ? (
              <OuterLeftWrapper>
                <LeftWrapper>
                  <WrapperOne>
                    <ButtonWrapper>
                      {buttonStatus.withdraw !== 'submitting' ? (
                        <StyledPrimaryButtonWithdraw
                          onClick={withdrawHandler}
                        >
                          Withdraw transaction
                        </StyledPrimaryButtonWithdraw>
                      ) : (
                        <StyledPrimaryButtonWithdrawClicked>
                          <LoadIcon src={SpinnerSrc} />
                          <LoadIconText>sending request</LoadIconText>
                        </StyledPrimaryButtonWithdrawClicked>
                      )}
                    </ButtonWrapper>
                  </WrapperOne>
                </LeftWrapper>
                <LeftWrapper>
                  <WrapperOne>
                    <ButtonWrapper>
                      {buttonStatus.confirm !== 'submitting' ? (
                        <StyledPrimaryButton
                          onClick={confirmHandler}
                        >
                          Confirm Cancellation
                        </StyledPrimaryButton>
                      ) : (
                        <StyledPrimaryButtonWithdrawClicked>
                          <LoadIcon src={SpinnerSrc} />
                          <LoadIconText>sending request</LoadIconText>
                        </StyledPrimaryButtonWithdrawClicked>
                      )}
                    </ButtonWrapper>
                  </WrapperOne>
                </LeftWrapper>
              </OuterLeftWrapper>
            ) : (
              <OuterLeftWrapper>
                {showUWReferralButton && showReferToUWButton ? (
                  <LeftWrapper>
                    <WrapperOne>
                      <ButtonWrapper>
                        {buttonStatus.uwRefer !== 'submitting' ? (
                          <StyledPrimaryButton
                            onClick={uwReferalHandler}
                          >
                            Refer to underwriter
                          </StyledPrimaryButton>
                        ) : (
                          <StyledPrimaryButtonWithdrawClicked>
                            <LoadIcon src={SpinnerSrc} />
                            <LoadIconText>sending request</LoadIconText>
                          </StyledPrimaryButtonWithdrawClicked>
                        )}
                      </ButtonWrapper>
                    </WrapperOne>
                  </LeftWrapper>
                ) : (<></>)}
                {/* <LeftWrapper>
                  <WrapperOne>
                    <ButtonWrapper>
                        {buttonStatus.confirm !== 'submitting' ? (
                          <StyledPrimaryButtonWithdraw
                            onClick={confirmHandler}
                          >
                            Confirm Cancellation
                          </StyledPrimaryButtonWithdraw>
                        ) : (
                          <StyledPrimaryButtonWithdrawClicked>
                            <LoadIcon src={SpinnerSrc} />
                            <LoadIconText>sending request</LoadIconText>
                          </StyledPrimaryButtonWithdrawClicked>
                        )}
                      </ButtonWrapper>
                  </WrapperOne>
                </LeftWrapper> */}
              </OuterLeftWrapper>
            )}
          </MainLeftWrapper>
        </MainWrapper>
      </CardLayout>
    </LayoutContainer>
  );
};

interface CancelPolicyFormSubmitedProps {
  result: any;
  systemCode: string;
  account_number: string | null;
  policy_number: string | null;
  query_env: string;
  confirmClickHandler: Function;
  withdrawSuccessHandler: Function;
  confirmCancel: Function;
  setIsUpdated: Function;
  product: string;
  uploadToken: string;
}

type ValidPolicyCancellationResponse = {
  valid_policy_cancellation: {
    data: string;
    __typename: string;
  };
};

type WithdrawPolicyCancelVariables = {
  account_number: string | null;
  policy_number: string | null;
  source_system_code: string;
  directPCCall: boolean;
  query_env: string;
  withdraw_policy_cancellation: boolean;
};

const sleep = (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export default ({
  result,
  systemCode,
  account_number,
  policy_number,
  query_env,
  withdrawSuccessHandler,
  setIsUpdated,
  product,
  confirmCancel,
  uploadToken
}: CancelPolicyFormSubmitedProps) => {
  const [formState, setFormState] = useState(initialState(product, systemCode));
  const [securityType, setSecurityType] = useState<string>('');
  const [uploadStatus, setUploadStatus] = useState<string>('upload');
  const [buttonStatus, setButtonStatus] = useState(initialButtonStatus);
  const [showUWReferralButton, setShowUWReferralButton] = useState(true);
  let isWorkerCompLine = false;
  let isFarmRanch = false;
  let isCommercialLine = false;
  let isCppLine = false;
  const cppProducts = ["General Liability", "COMMERCIAL PACKAGE", "Inland Marine"];
  const farmRanchProducts = ["Farm & Ranch Line", "Farm Auto Line", "Farm Umbrella Line"];
  if (product === "WORKERS COMP") {
    isWorkerCompLine = true;
  } else if (cppProducts.includes(product)) {
    isCppLine = true;
  } else if (farmRanchProducts.includes(product)) {
    isFarmRanch = true;
  } else {
    isCommercialLine = true;
  };

  const cancelPolicyTransactionResult = useQuery(get_uwreferral_lock, {
    variables: {
      policy_number,
      source_system_code: systemCode,
      query_env,
      uwReferral: true,
      product,
      get_transaction: true
    }
  });

  const { data: transactionData } = cancelPolicyTransactionResult;
  let isCancellationTransactionBlocked = false;
  if (transactionData) {
    const latestTransaction = transactionData && transactionData?.refer_to_underwriter && JSON.parse(transactionData?.refer_to_underwriter?.data);
    isCancellationTransactionBlocked = latestTransaction && latestTransaction?.isLocked ? true : false;
  }

  const showReferToUWButton = (isCommercialLine || isFarmRanch || isWorkerCompLine) && !isCppLine && !isCancellationTransactionBlocked;
  const [docUploaded, setDocUploaded] = useState<boolean>(false);
  const [warning, setWarning] = useState(false);


  const [withdrawClickHandler, { data }] = useLazyQuery<ValidPolicyCancellationResponse, WithdrawPolicyCancelVariables>(
    withdraw_policy_cancel
  );

  const [getUWReferralLock, uwReferralResponse] = useLazyQuery(
    get_uwreferral_lock, {
    onError: (error: any) => {
      console.error('GraphQL Error:', error);
    }
  }
  );

  const [uploadDoc, { error }] = useMutation(upload_policy_document_mutation);

  const { data: uwReferralData, loading: uwReferralIsLoading, error: uwReferralError } = uwReferralResponse;

  useEffect(() => {
    if (uwReferralData?.refer_to_underwriter?.data === "lock_successful") {
      setIsUpdated(true);
      setShowUWReferralButton(false);
    }
  }, [uwReferralData, setIsUpdated]);

  useEffect(() => {
    if (data?.valid_policy_cancellation?.data === 'withdraw_successful') {
      withdrawSuccessHandler();
    }
  }, [data, withdrawSuccessHandler]);

  useEffect(() => {
    if (!!formState.cancellationDocument.file) {
      setDocUploaded(true);
      setWarning(false);
    }
  }, [formState.cancellationDocument.file]);

  const withdrawHandler = async () => {
    setButtonStatus({ ...buttonStatus, withdraw: 'submitting' });
    withdrawClickHandler({
      variables: {
        account_number,
        policy_number,
        source_system_code: systemCode,
        directPCCall: true,
        query_env,
        withdraw_policy_cancellation: true,
      }
    });
    setButtonStatus({ ...buttonStatus, withdraw: 'submitted' });
  };

  const translateDocument = async (f: Blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = () => resolve(reader.result);
      reader.onerror = err => {
        reject(err);
        return null;
      };
    });

  const confirmHandler = async () => {
    if (systemCode === 'GWPL' && !!formState.cancellationDocument.file) {
      setDocUploaded(true);
      setWarning(false);
    } else if (systemCode === 'GWPL' && !docUploaded) {
      setWarning(true);
    }
    if (systemCode === 'GWPL' && docUploaded && isValid()) {
      try {
        const docData = await translateDocument(formState.cancellationDocument.file!);
        await uploadDoc({
          variables: {
            policy_number: policy_number,
            file_name: formState.cancellationDocument.fileName,
            mime_type: formState.cancellationDocument.file?.type,
            document_type: 'letter_received',
            security_type: securityType,
            source_system_code: systemCode,
            document_data: docData,
            query_env: query_env,
            token: uploadToken || ""
          }
        });
      } catch (err) {
        console.log('error uploading doc', err);
      }
    }
    if (!warning && docUploaded) {
      if ((systemCode === 'GWPL' && isValid()) || systemCode === 'GWCL') {
        setButtonStatus({ ...buttonStatus, confirm: 'submitting' });
        await confirmCancel();
        setButtonStatus({ ...buttonStatus, confirm: 'submitted' });
      }
    }
  };

  const uwReferalHandler = async () => {
    try {
      setButtonStatus({ ...buttonStatus, uwRefer: 'submitting' });
      getUWReferralLock({
        variables: {
          policy_number,
          source_system_code: systemCode,
          query_env,
          uwReferral: true,
          product,
          get_transaction: false
        }
      });
      setButtonStatus({ ...buttonStatus, uwRefer: 'submitted' });
    } catch (err) {
      console.error('Error on UW Referral Lock:', err);
    }
  };

  const isValid = () => {
    let isValid = true;
    const {
      cancellationDocument
    } = formState;
    if (
      uploadStatus === 'upload' &&
      !isCancellationDocumentValid(
        uploadStatus,
        cancellationDocument.file,
        cancellationDocument.fileName
      )
    ) {
      isValid = false;
      formState.cancellationDocument = {
        ...cancellationDocument,
        error: true,
        msg:
          'You must upload a signed Cancellation Request/Policy Release (LPR)'
      };
    }

    if (uploadStatus === 'upload' && securityType === '') {
      isValid = false;
      formState.cancellationDocument = {
        ...cancellationDocument,
        error: true,
        msg: 'Select where do you want to send the document'
      };
    }

    if (!isValid) {
      setFormState({ ...formState });
    }

    return isValid;
  };

  const handleChange = (
    field: string,
    value: string | File | null,
    fileName?: string
  ) => {
    const updateObj = {
      error: false,
      msg: ''
    };

    const {
      cancellationDocument
    } = formState;
    if (
      field === 'cancellationDocument' &&
      typeof value !== 'string' &&
      fileName
    ) {
      formState.cancellationDocument = {
        ...cancellationDocument,
        ...updateObj,
        file: value,
        fileName
      };
    }

    setFormState({ ...formState });
  };

  return (
    <>
      {/* {uwReferralIsLoading && <BounceLoaderComponent />} */}

      {uwReferralError && (
        <div style={{ color: 'red' }}>Error fetching UW referral lock: {uwReferralError.message}</div>
      )}

      {/* {!uwReferralIsLoading && !uwReferralError && result?.result?.effectiveDate && ( */}
      {result?.result?.effectiveDate && (
        CancelPolicyInfoWrapper(
          result,
          withdrawHandler,
          confirmHandler,
          uwReferalHandler,
          buttonStatus,
          systemCode,
          showUWReferralButton,
          showReferToUWButton,
          formState,
          setFormState,
          handleChange,
          securityType,
          setSecurityType,
          uploadStatus,
          setUploadStatus,
          warning,
          setWarning
        )
      )}
    </>
  );
};
